import { z } from 'zod';
import { VisitedEventsResponseDto } from '../me-visited-events';

/** Краткая сводка для компактной карточки CRM. */
export const CrmManagerEventInterestsSummaryDto = z.object({
  hasText: z.boolean(),
  tagCount: z.number().int().nonnegative(),
});
export type CrmManagerEventInterestsSummaryDto = z.infer<typeof CrmManagerEventInterestsSummaryDto>;

export const CrmManagerEventInterestsAuthorDto = z.object({
  id: z.uuid(),
  username: z.string().nullable(),
  firstName: z.string().nullable(),
});
export type CrmManagerEventInterestsAuthorDto = z.infer<typeof CrmManagerEventInterestsAuthorDto>;

/** Заметки менеджера об интересах к мероприятиям (отдельно от данных пользователя). */
export const CrmManagerEventInterestsDto = z.object({
  contactUserId: z.uuid(),
  text: z.string().max(4000).nullable(),
  tags: z.array(z.string().min(1).max(64)).max(10),
  updatedAt: z.iso.datetime().nullable(),
  updatedBy: CrmManagerEventInterestsAuthorDto.nullable(),
  summary: CrmManagerEventInterestsSummaryDto,
});
export type CrmManagerEventInterestsDto = z.infer<typeof CrmManagerEventInterestsDto>;

export const CrmPatchManagerEventInterestsBody = z.object({
  text: z.string().max(4000).nullable().optional(),
  tags: z.array(z.string()).max(10).optional(),
});
export type CrmPatchManagerEventInterestsBody = z.infer<typeof CrmPatchManagerEventInterestsBody>;

/** Resolved «Мероприятия» из ProfileFacet (read-only для CRM). */
export const CrmUserEventsFacetDto = z.object({
  about: z.string().nullable(),
  tags: z.array(z.string()),
});
export type CrmUserEventsFacetDto = z.infer<typeof CrmUserEventsFacetDto>;

/** Контекст контакта для подбора приглашений (без LLM). */
export const CrmContactContextDto = z.object({
  contactUserId: z.uuid(),
  managerEventInterests: CrmManagerEventInterestsDto,
  userEventsFacet: CrmUserEventsFacetDto,
  /** Прошедшие события с CONFIRMED-участием, без событий где контакт организатор. */
  visitedEvents: VisitedEventsResponseDto,
  /** События, где контакт организатор (аккаунт или legacy organizerUsername). */
  organizedEvents: VisitedEventsResponseDto,
});
export type CrmContactContextDto = z.infer<typeof CrmContactContextDto>;
